var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74829 9.99871C6.74829 11.7765 8.20357 13.2229 10.0003 13.2229C11.7889 13.2229 13.2442 11.7765 13.2442 9.99871C13.2442 8.21285 11.7889 6.76638 10.0003 6.76638C8.20357 6.76638 6.74829 8.21285 6.74829 9.99871ZM14.7808 5.03708C16.2036 6.13607 17.415 7.74415 18.2849 9.75627C18.3499 9.90981 18.3499 10.0876 18.2849 10.233C16.545 14.2573 13.4475 16.6654 10.0003 16.6654H9.9922C6.55317 16.6654 3.45561 14.2573 1.71577 10.233C1.65073 10.0876 1.65073 9.90981 1.71577 9.75627C3.45561 5.73203 6.55317 3.33203 9.9922 3.33203H10.0003C11.7239 3.33203 13.3581 3.93001 14.7808 5.03708ZM10.0013 12.009C11.1151 12.009 12.0257 11.104 12.0257 9.99692C12.0257 8.88177 11.1151 7.97672 10.0013 7.97672C9.90374 7.97672 9.80617 7.9848 9.71674 8.00096C9.68422 8.88985 8.95252 9.60096 8.05008 9.60096H8.00943C7.98504 9.73025 7.96878 9.85954 7.96878 9.99692C7.96878 11.104 8.87934 12.009 10.0013 12.009Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eyeIcon.ec70653195e3ed9a038b3e72e14f8aa3.svg";
export { ForwardRef as ReactComponent };